module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_vue-template-compiler@2.7.16_webpack@2.7.0/~/vue-loader/lib/template-compiler?{"id":"data-v-3902bcd5"}!./~/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_vue-template-compiler@2.7.16_webpack@2.7.0/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/wechat-login.vue
// module id = 1126
// module chunks = 1